import React, { ReactNode } from "react";
import { useSpring, animated } from "react-spring";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  children: ReactNode;
  delay?: number;
  duration?: number;
}

// == Constants ============================================================

// == Component ============================================================

const FadeIn = ({ duration = 1000, delay = 0, children }: IProps) => {
  const fadeIn = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    config: { duration },
    delay,
  });
  return <animated.div style={fadeIn}>{children}</animated.div>;
};

export default FadeIn;

// == Styles ===============================================================
